export const experiences = [
  {
    company: "Randa Apparel & Accessories",
    position: "Desarrollador Full Stack",
    period: "Agosto 2024 - Presente",
    responsibilities: [
      "Lideré la creación, pruebas y publicación de una librería interna de componentes UI en React.js alojada en Azure DevOps Artifacts, agilizando el desarrollo frontend en las diferentes divisiones de la empresa",
      "Desarrollo, mantenimiento y optimización de interfaces de usuario responsivas utilizando la librería centralizada de componentes, asegurando el cumplimiento de los estrictos lineamientos corporativos de diseño UX/UI",
      "Construcción y mantenimiento de una API central en C# para la gestión de múltiples bases de datos, facilitando el acceso seguro a datos en tiempo real y la consistencia transaccional",
      "Diseño y optimización de paquetes complejos de SQL Server Integration Services (SSIS) para la manipulación, migración y transformación de datos a gran escala",
    ],
    technologies: [
      "React",
      "TypeScript",
      "JavaScript",
      "SQLServer",
      "SSIS",
      "C#",
      "Azure DevOps",
      "Docker",
      "Git",
    ],
  },
  {
    company: "Freelance",
    position: "Desarrollador Full Stack",
    period: "Octubre 2018 - Presente",
    responsibilities: [
      "Desarrollo e implementación de API para factura electrónica FEL",
      "Diseño y desarrollo de serivicos web y RESTful APIs con .NET Framework",
      "Creación de reportes con JasperReports",
      "Desarrollo de aplicación móvil para proveer de asistencia médica a los usuarios mediante geolocalización y sensor de movimiento",
      "Desarrollo de sistemas a la medida en diferentes tecnologías",
      "Desarrollo de Sistema de tickets para proveer soporte en tiempo real, mejorando la respuesta en la resolución de estos en un 65%",
      "Generación de prototipos, mockups, y wireframes en Figma"
    ],
    technologies: [
      "Ruby on Rails",
      "Laravel",
      "Java",
      "Spring",
      "JasperReports",
      "API Rest",
      "Docker",
      "Git",
      "GitLab",
      "Angular",
      "React",
      "JavaScript",
      "Oracle",
      "MySQL",
      "SQL",
      "Jira",
      "Trello",
      "Kotlin",
      "Android",
      "Python",
      "Flask",
      "FastAPI",
      "PostgreSQL",
      "MongoDB",
      "Firebase",
      "AWS",
      "Netlify",
      "Figma",
    ],
  },
  {
    company: "Udemy",
    position: "Profesor Auxiliar - Curso de Java",
    period: "2023 - Presente",
    responsibilities: [
      "Brindo apoyo y resuelvo dudas de los estudiantes inscritos en el curso de Java, guiándolos en la comprensión de conceptos y en la resolución de ejercicios prácticos",
      "Acompañamiento continuo a los estudiantes a lo largo del curso, ayudando a mantener su motivación y buen ritmo de aprendizaje",
    ],
    technologies: ["Java", "JavaFX", "MySQL", "MariaDB"],
  },
  {
    company: "PAKAI Consultores",
    position: "Desarrollador Full Stack",
    period: "Noviembre 2023 - Agosto 2024",
    responsibilities: [
      "Desarrollo de nuevas funcionalidades para un sistema de seguros de gastos médicos",
      "Microservicios con SpringBoot para generación de pólizas, exclusión de riesgos, y creación de cotizaciones",
      "Creación de reportes con JasperReports para pólizas y endosos",
      "Desarrollo de nuevas funcionalidades para sistemas legacy (AngularJS) donde se realizaban autorizaciones para medicamentos y laboratorios de los asegurados a través de una API de terceros",
      "Creación y modificación de procesos automatizados (RPA) con UIPath",
    ],
    technologies: [
      "Java",
      "Spring",
      "JasperReports",
      "API Rest",
      "Docker",
      "Git",
      "GitLab",
      "Angular",
      "AngularJS",
      "JavaScript",
      "UIpath",
      "SonarQube",
      "Grafana",
      "MariaDB",
      "Oracle",
      "MySQL",
      "SQL",
      "Jira",
    ],
  },
  {
    company: "EMPAGUA",
    position: "Desarrollador Full Stack (Contractor)",
    period: "Julio 2023 - Diciembre 2023",
    responsibilities: [
      "Desarrollo de un módulo para el pago del servicio de agua para los residentes de la ciudad de Guatemala, a través de un quiosco de la Municipalidad",
      "Desarrollo de una aplicación lowcode con Oracle APEX para la administración de herramientas e inventario en las bodegas de la empresa",
      "Creación de una aplicación con Oracle APEX para",
    ],
    technologies: [
      "Oracle APEX",
      "JasperReports",
      "PHP",
      "Laravel",
      "Ruby on Rails",
      "JavaScript",
      "Git",
      "GitHub",
      "Docker",
      "HTML",
      "CSS",
      "Oracle",
      "SQL",
    ],
  },
  {
    company: "Silicon Development",
    position: "Desarrollador Ruby on Rails",
    period: "Julio 2022 - Junio 2023",
    responsibilities: [
      "Creación de nuevos endpoints para la API de inversiones interna, así como nuevas funcionalidades en el sistema multitenant",
      "Integración con APIs de terceros (i.e. Docusign), para expandir las capacidades del sistema a la vez que se aseguraba la comunicación con servicios externos",
      "Asistencia en el proceso de migración, contribuyendo en la transición de Rails 5 a Rails 7, y de Ruby 2 a Ruby 3",
      "Desarrollo con orientación a TDD, contribuyendo a una cultura de calidad y seguridad a través de todo el ciclo de desarrollo",
      "Documentación de código y procesos",
    ],
    technologies: [
      "Ruby on Rails",
      "React",
      "JavaScript",
      "API Rest",
      "Git",
      "GitHub",
      "Docker",
      "Heroku",
      "AWS",
      "Redis",
      "PostgreSQL",
      "Scrum",
      "CircleCI",
      "Jira",
    ],
  },
  {
    company: "TektonLabs",
    position: "Desarrollador Full Stack (Contractor)",
    period: "Agosto 2022 - Diciembre 2022",
    responsibilities: [
      "Desarrollo e implementación con éxito de un sistema de reservas sólido y robusto para programar citas o eventos con celebridades y oradores de diferentes ámbitos, a través de interfaces fáciles de utilizar y procesos optimizados para una excelente experiencia",
      "Diseño e implementación de un sistema de búsqueda con múltiples filtros en el sitio web principal, mejorando la navegación y brindando experiencia personalizada",
      "Se crearon y lanzaron sitios web secundarios individuales para diferentes categorías y clientes, optimizando la participación del usuario para adaptar el contenido y funcionalidades a los intereses específicos de sus audiencias",
      "Desarrollo con orientación a TDD, contribuyendo a una cultura de calidad y seguridad a través de todo el ciclo de desarrollo",
      "Creación de sección administrativa para todos los sitios web, esta sección mejoró la usabilidad y control general del sistema",
      "Documentación de código y procesos",
    ],
    technologies: [
      "Ruby on Rails",
      "JavaScript",
      "Git",
      "GitHub",
      "Docker",
      "AWS",
      "Redis",
      "PostgreSQL",
      "Scrum",
      "Jira",
    ],
  },
  {
    company: "Agropecuaria Popoyán",
    position: "Desarrollador y Consultor de Software (Contractor)",
    period: "Mayo 2022 - Septiembre 2022",
    responsibilities: [
      "Implementación del módulo de Private Shops dentro de Magento para tener tiendas privadas con productos génericos",
      "Investigación de integración de módulos de terceros para las tiendas B2B y B2C, facilitando la integración de diferentes productos dentro de los dos tipos de tiendas",
    ],
    technologies: [
      "Magento",
      "PHP",
      "JavaScript",
      "API Rest",
      "Git",
      "GitHub",
      "Docker",
      "Nginx",
      "Elasticsearch",
      "MySQL",
      "Scrum",
      "Jira",
    ],
  },
  {
    company: "PDC Latinoamerica",
    position: "Desarrollador y Consultor de Aplicaciones",
    period: "Mayo 2020 - Enero 2022",
    responsibilities: [
      "Desarollo de un módulo de reservas (espacios administrativos, oficinas, salas, parqueos, citas), optimizando el uso y administración de los recursos",
      "Desarrollo de mejoras en el módulo de vacaciones, contribuyendo a la optimización de procesos y un mejor seguimiento de los días de licencias de los empleados",
      "Implementación de mejoras en el módulo de datos demográficos, lo que mejoró la precisión y relevancia de los datos organizacionales para la toma de decisiones estratégicas",
      "Desarrollo de interfaz gráfica para la visualización de módulo del sistema ERP",
      "Diseño e implementación de un sistema de encuestas de satisfacción y fidelidad para clientes, lo que proporcionó información valiosa para las estrategias de la empresa",
      "Soporte sobre procesos en el sistema ERP",
    ],
    technologies: [
      "Ruby on Rails",
      "Python",
      "JavaScript",
      "TypeScript",
      "Git",
      "GitHub",
      "Node.js",
      "Angular",
      "Oracle",
      "Redis",
      "HTML",
      "CSS",
    ],
  },
  {
    company: "INFILE",
    position:
      "Desarrollador Web | Jefe de Implementación | Implementador y Soporte Técnico",
    period: "Diciembre 2012 - Abril 2020",
    responsibilities: [
      "Desarollo de un pequeño ecosistema de facturación electrónica FEL para BAC Credomatic (API, Portal Web, Aplicación lectora de archivos, Colas, Envío de Correos) utilizando Docker para procesar archivos, convertir archivos, consumir API, almacenar en base de datos y envío de correos electrónicos de forma individual y masiva",
      "Interfaz de factura electrónica FEL para inmobiliaria Spectrum",
      "Mejoras y actualizaciones en el CRM corporativo para FEL y conecciones a SAP",
      "Desarrollo y modificación de bibliotecas (DLL) para reutilización de código en diferentes proyectos",
      "Desarrollo de aplicación de escritorio para consumir servicios SOAP, obteniendo información de los contribuyentes y almacenándolos en una base de datos, proceso que se ejecutaba periódicamente a través de un cronjob",
      "A cargo de la coordinación de el equipo de implementaciones y soporte técnico para ayudar a los clientes en el uso de los sistemas para la facturación electrónica",
      "Soporte en diferentes tecnologías y lenguajes para clientes en implementación de factura electrónica",
    ],
    technologies: [
      "Java",
      "PHP",
      "Ruby on Rails",
      "Python",
      "JavaScript",
      "TypeScript",
      "C#",
      "Angular",
      "Node.js",
      "Git",
      "GitHub",
      "Redis",
      "HTML",
      "CSS",
      "Docker",
      "Oracle",
      "MySQL",
      "SQLServer",
      "Visual Basic",
      "Visual Fox",
    ],
  },
];
